// extracted by mini-css-extract-plugin
export default {"recommendationContainer":"RecommendationStack_recommendationContainer__HmuFM"};